export default __webpack_public_path__ + "static/media/Half-Letter-5.5-x-8.5in.8da8740e.png";